import React, { useEffect } from 'react';
import Answer from './Answer';
import { QuestionProps } from './types';
import { InputEvent } from '../StageZero/types';
import TextField from '@mui/material/TextField';
import { Button, Paper } from '@mui/material';
import { Grid } from '@mui/material';
import { autoId } from '../../utils/UidGenerator';
import { Task, Option } from '../../store/tasks/types';
import OptionTypes from '../../resources/enums/OptionTypes';

const Question: React.FC<QuestionProps> = (props) => {
    const [options, setOptions] = React.useState<Option[]>([]);
    const [currentTask] = React.useState<Task | undefined>(props.tasks.find((x) => x.id === props?.id));

    const createNewItem = () => {
        return { id: autoId(), type: OptionTypes.Text, skills: {}, text: {} } as Option;
    };

    const updateTask = (e: InputEvent) => {
        const { value } = e.target;
        const before = props.tasks.find((x) => x.id === props?.id);
        if (before) {
            if (!before?.description) before.description = {};
            const modifiedTask = {
                ...before,
                description: { ...before.description, [props.language]: value },
            };
            props.setTasks(
                props.tasks.map((task) => {
                    return task.id !== props.id ? task : modifiedTask;
                }),
            );
        }
    };

    useEffect(() => {
        if (currentTask?.options) setOptions(currentTask?.options);
        else setOptions([createNewItem()]);
    }, [currentTask]);

    useEffect(() => {
        props.setTasks(
            props.tasks.map((task) => {
                return task.id !== props.id ? task : { ...task, options: options };
            }),
        );
    }, [options]);

    const handleClick = () => {
        setOptions([...options, createNewItem()]);
    };

    return (
        <div>
            <Paper className="task-paper" elevation={2}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        {props.languages.map((lang) => (
                            <TextField
                                fullWidth
                                style={{ display: lang.code === props.language ? 'block' : 'none', border: 'solid 1' }}
                                key={`${props.id}_description_${lang.code}`}
                                defaultValue={currentTask?.description?.[lang.code]}
                                variant="outlined"
                                required={false}
                                type="text"
                                id={`${props.id}_description_${lang.code}`}
                                label="Question"
                                name={`${props.id}_description_${lang.code}`}
                                onChange={updateTask}
                            ></TextField>
                        ))}
                    </Grid>
                    <Grid item xs={12}>
                        {options.map((option) => {
                            return (
                                <Answer
                                    key={option.id}
                                    id={option.id}
                                    feedback={option.feedback}
                                    feedbackVisible={props.feedbackVisible}
                                    text={option.text}
                                    language={props.language}
                                    languages={props.languages}
                                    skillsCollection={props.skills}
                                    skills={option.skills}
                                    options={options}
                                    setOptions={setOptions}
                                ></Answer>
                            );
                        })}
                    </Grid>
                    <Grid item xs={12} justifyContent="left">
                        <Button variant="outlined" onClick={handleClick}>
                            Add answer
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
};

export default Question;
